import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "./controlInput";

export interface ControlImageProps extends ControlTemplateProps {

}

export const ControlImage: React.FC<ControlImageProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="image" {...ComponentProps(props)} style={{ ...styles.image ?? styles.text ?? styles.input, ...props.style }} />        
    );
};